<template>
  <v-row class="unit">
    <v-col cols="12" sm="9">
      {{ $t('auth.orderAs') }} <strong class="user-email" data-attr="user-email">{{email}}</strong>
    </v-col>
    <v-col cols="12" sm="3">
      <div class="login">
        <span class="link-b" @click="goToLogOut()" data-attr="sign-out">{{ $t('auth.signOut') }}</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import { mapGetters } from "vuex";
  import { SETTINGS_GETTERS, SETTINGS_MUTATIONS } from "@/store/modules/settings";

  export default {
    name: "LoggedOn",
    computed: {
      ...mapGetters('settings', {
        authorization: SETTINGS_GETTERS.AUTH,
      }),
      email() {
        return this.authorization && this.authorization.auth ? this.authorization.auth.email : '';
      }
    },
    methods: {
      goToLogOut() {
        const WHMCS = document.cookie && (document.cookie.split(";").find(cook => cook.match(/WHMCS[a-zA-Z0-9]{12}=/)) || '').split("=")[0] || '';
        document.cookie = `${WHMCS}=;max-age=31536000;path=/`;
        document.cookie = `WHMCSUser=;max-age=31536000;path=/`;
        this.$store.commit(`settings/${SETTINGS_MUTATIONS.SET_AUTH}`, {});
      },
    }
  }
</script>
